// extracted by mini-css-extract-plugin
export default {"languageMenuDesktop":"languageMenu_languageMenuDesktop__tWbGj","language":"languageMenu_language__F1W02","languageMenuMobile":"languageMenu_languageMenuMobile__aRzh8"};